<div *ngIf="request.reply.replyItems[Index].isDone && request.reply.replyItems[Index].replyForm">
  <div *ngIf="request.reply.replyItems[Index].solutionStep.actionForm.reference" class="row mb-1">
    <div class="col-md-4">
      <div class="row pb-2">
        <div class="col-6 font-weight-bold">{{'doctrine.solution.action_form.reference'|translate}}</div>
        <div class="col-6">{{request.reply.replyItems[Index].replyForm.reference  ? request.reply.replyItems[Index].replyForm.reference : ''}}</div>
      </div>
    </div>
  </div>
  <div *ngIf="request.reply.replyItems[Index].solutionStep.actionForm.country" class="row mb-1">
    <div class="col-md-4">
      <div class="row pb-2">
        <div class="col-6 font-weight-bold">{{'doctrine.solution.action_form.country'|translate}}</div>
        <div class="col-6">{{request.reply.replyItems[Index].replyForm.country ? request.reply.replyItems[Index].replyForm.country : ''}}</div>
      </div>
    </div>
  </div>
  <div *ngIf="request.reply.replyItems[Index].solutionStep.actionForm.city" class="row mb-1">
    <div class="col-md-4">
      <div class="row pb-2">
        <div class="col-6 font-weight-bold">{{'doctrine.solution.action_form.city'|translate}}</div>
        <div class="col-6">{{request.reply.replyItems[Index].replyForm.city ? request.reply.replyItems[Index].replyForm.city : ''}}</div>
      </div>
    </div>
  </div>
  <div *ngIf="request.reply.replyItems[Index].solutionStep.actionForm.street" class="row mb-1">
    <div class="col-md-4">
      <div class="row pb-2">
        <div class="col-6 font-weight-bold">{{'doctrine.solution.action_form.street'|translate}}</div>
        <div class="col-6">{{request.reply.replyItems[Index].replyForm.street ? request.reply.replyItems[Index].replyForm.street : ''}}</div>
      </div>
    </div>
  </div>
  <div *ngIf="request.reply.replyItems[Index].solutionStep.actionForm.houseNumber" class="row mb-1">
    <div class="col-md-4">
      <div class="row pb-2">
        <div class="col-6 font-weight-bold">{{'doctrine.solution.action_form.houseNumber'|translate}}</div>
        <div class="col-6">{{request.reply.replyItems[Index].replyForm.houseNumber ? request.reply.replyItems[Index].replyForm.houseNumber : ''}}</div>
      </div>
    </div>
  </div>
  <div *ngIf="request.reply.replyItems[Index].solutionStep.actionForm.postalCode" class="row mb-1">
    <div class="col-md-4">
      <div class="row pb-2">
        <div class="col-6 font-weight-bold">{{'doctrine.solution.action_form.postalCode'|translate}}</div>
        <div class="col-6">{{request.reply.replyItems[Index].replyForm.postalCode ? request.reply.replyItems[Index].replyForm.postalCode : ''}}</div>
      </div>
    </div>
  </div>
  <div *ngIf="request.reply.replyItems[Index].solutionStep.actionForm.phoneNumber" class="row mb-2">
    <div class="col-md-4">
      <div class="row pb-2">
        <div class="col-6 font-weight-bold">{{'doctrine.solution.action_form.phoneNumber'|translate}}</div>
        <div class="col-6">{{request.reply.replyItems[Index].replyForm.phoneNumber ? request.reply.replyItems[Index].replyForm.phoneNumber : ''}}</div>
      </div>
    </div>
  </div><div *ngIf="request.reply.replyItems[Index].solutionStep.actionForm.email" class="row mb-2">
    <div class="col-md-4">
      <div class="row pb-2">
        <div class="col-6 font-weight-bold">{{'doctrine.solution.action_form.email'|translate}}</div>
        <div class="col-6">{{request.reply.replyItems[Index].replyForm.email ? request.reply.replyItems[Index].replyForm.email : ''}}</div>
      </div>
    </div>
  </div>
  <div *ngIf="request.reply.replyItems[Index].solutionStep.actionForm.extraField" class="row">
    <div class="col-md-4">
      <div class="border-checkbox-section">
        <div class="border-checkbox-group border-checkbox-group-primary">
          <input type="checkbox" class="border-checkbox" [id]="Index+'form_extraField'" [disabled]="true" [checked]="request.reply.replyItems[Index].replyForm.extraField">
          <label [for]="Index+'form_extraField'" class="border-checkbox-label">{{request.reply.replyItems[Index].solutionStep.actionForm.extraFieldName}}</label>
        </div>
      </div>
    </div>
  </div>
</div>


<div *ngIf="!request.reply.replyItems[Index].isDone">
  <div *ngIf="request.reply.replyItems[Index].solutionStep.actionForm?.reference" class="row mb-1">
    <div class="col-md-8">
      <div class="row pb-2">
        <div class="col-3 font-weight-bold">{{'doctrine.solution.action_form.reference'|translate}}<span class="star">*</span></div>
        <div class="col-9">
          <input [name]="Index+'form-refrence'"
            class="form-control"
            (ngModelChange)="validateForm()"
            required
            [(ngModel)]="request.reply.replyItems[Index].replyForm.reference">
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="request.reply.replyItems[Index].solutionStep.actionForm?.country" class="row mb-1">
    <div class="col-md-8">
      <div class="row pb-2">
        <div class="col-3 font-weight-bold">{{'doctrine.solution.action_form.country'|translate}}<span class="star">*</span></div>
        <div class="col-9">
          <input [name]="Index+'form-country'"
            class="form-control"
            (ngModelChange)="validateForm()"
            required
            [(ngModel)]="request.reply.replyItems[Index].replyForm.country">
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="request.reply.replyItems[Index].solutionStep.actionForm?.city" class="row mb-1">
    <div class="col-md-8">
      <div class="row pb-2">
        <div class="col-3 font-weight-bold">{{'doctrine.solution.action_form.city'|translate}}<span class="star">*</span></div>
        <div class="col-9">
          <input [name]="Index+'form-city'"
            class="form-control"
            (ngModelChange)="validateForm()"
            required
            [(ngModel)]="request.reply.replyItems[Index].replyForm.city">
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="request.reply.replyItems[Index].solutionStep.actionForm?.street" class="row mb-1">
    <div class="col-md-8">
      <div class="row pb-2">
        <div class="col-3 font-weight-bold">{{'doctrine.solution.action_form.street'|translate}}<span class="star">*</span></div>
        <div class="col-9">
          <input [name]="Index+'form-street'"
            class="form-control"
            (ngModelChange)="validateForm()"
            required
            [(ngModel)]="request.reply.replyItems[Index].replyForm.street">
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="request.reply.replyItems[Index].solutionStep.actionForm?.houseNumber" class="row mb-1">
    <div class="col-md-8">
      <div class="row pb-2">
        <div class="col-3 font-weight-bold">{{'doctrine.solution.action_form.houseNumber'|translate}}<span class="star">*</span></div>
        <div class="col-9">
          <input [name]="Index+'form-houseNumber'"
            class="form-control"
            (ngModelChange)="validateForm()"
            required
            [(ngModel)]="request.reply.replyItems[Index].replyForm.houseNumber">
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="request.reply.replyItems[Index].solutionStep.actionForm?.postalCode" class="row mb-1">
    <div class="col-md-8">
      <div class="row pb-2">
        <div class="col-3 font-weight-bold">{{'doctrine.solution.action_form.postalCode'|translate}}<span class="star">*</span></div>
        <div class="col-9">
          <input [name]="Index+'form-postalCode'"
            class="form-control"
            (ngModelChange)="validateForm()"
            required
            [(ngModel)]="request.reply.replyItems[Index].replyForm.postalCode">
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="request.reply.replyItems[Index].solutionStep.actionForm?.phoneNumber" class="row mb-2">
    <div class="col-md-8">
      <div class="row pb-2">
        <div class="col-3 font-weight-bold">{{'doctrine.solution.action_form.phoneNumber'|translate}}<span class="star">*</span></div>
        <div class="col-9">
          <input [name]="Index+'form-phoneNumber'"
            class="form-control"
            (ngModelChange)="validateForm()"
            required
            [(ngModel)]="request.reply.replyItems[Index].replyForm.phoneNumber">
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="request.reply.replyItems[Index].solutionStep.actionForm?.email" class="row mb-2">
    <div class="col-md-8">
      <div class="row pb-2">
        <div class="col-3 font-weight-bold">{{'doctrine.solution.action_form.email'|translate}}<span class="star">*</span></div>
        <div class="col-9">
          <input [name]="Index+'form-email'"
            #emailModel="ngModel"
            type="email"
            class="form-control"
            [class.is-invalid]="emailModel.invalid && emailModel.dirty"
            [placeholder]="'exchange.email_placeholder'|translate"
            (ngModelChange)="validateForm()"
            required
            email
            [(ngModel)]="request.reply.replyItems[Index].replyForm.email">
          <div class="messages text-danger" *ngIf="emailModel.invalid && emailModel.dirty && emailModel.errors?.required">
            <span>{{'errors.required'|translate}}</span>
          </div>
          <div class="messages text-danger" *ngIf="emailModel.invalid && emailModel.dirty && emailModel.errors?.email">
            <span>{{'errors.invalid'|translate}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="request.reply.replyItems[Index].solutionStep.actionForm?.extraField" class="row">
    <div class="col-md-8">
      <div class="border-checkbox-section">
        <div class="border-checkbox-group border-checkbox-group-primary">
          <input type="checkbox" class="border-checkbox" [id]="Index+'form_extraField'" (ngModelChange)="validateForm()" [(ngModel)]="request.reply.replyItems[Index].replyForm.extraField">
          <label [for]="Index+'form_extraField'" class="border-checkbox-label">{{request.reply.replyItems[Index].solutionStep.actionForm?.extraFieldName}}</label>
        </div>
      </div>
    </div>
  </div>
</div>

<button *ngIf="!request.reply.replyItems[Index].isDone"
 [disabled]="!isValidForm" class="btn btn-primary ripple light pull-right my-3" (click)="confirmStep()" type="button">{{'global.send'|translate}}</button>


